import { SurveyOption } from '@/api';

const triggerHaptic = (type: 'light' | 'medium' | 'heavy' = 'light') => {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(JSON.stringify({ triggerHaptic: type }));
  }
};

interface RadioQuestionProps {
  questionId: number;
  options: SurveyOption[];
  value: string | undefined;
  onChange: (questionId: number, value: string) => void;
}

const RadioQuestion = ({ questionId, options, value, onChange }: RadioQuestionProps) => {
  const maxTextLength = Math.max(...options.map((o) => o.optionText.length));
  const minWidth = Math.max(90, maxTextLength * 10 + 50);

  const handleChange = (optionId: number) => {
    triggerHaptic('light');
    onChange(questionId, String(optionId));
  };

  return (
    <div
      className="grid gap-[10px]"
      style={{
        gridTemplateColumns: `repeat(auto-fit, minmax(${minWidth}px, 1fr))`
      }}
    >
      {options.map((option) => {
        const isSelected = value === String(option.optionId);
        return (
          <label
            key={option.optionId}
            className={`flex h-[43px] w-full cursor-pointer items-center justify-center gap-[10px] rounded-[10px] border border-[#111111] px-4 transition-colors ${
              isSelected ? 'bg-[#D0FFEB]' : 'bg-white hover:bg-[#EFEFEF]'
            }`}
          >
            <input
              type="radio"
              name={`question-${questionId}`}
              value={option.optionId}
              checked={isSelected}
              onChange={() => handleChange(option.optionId)}
              className="hidden"
            />
            <span className="break-words text-center font-Pretendard text-[15px] font-semibold leading-[90%] tracking-normal text-[#111111]">
              {option.optionText}
            </span>
          </label>
        );
      })}
    </div>
  );
};

export default RadioQuestion;
